export const SIGN_IN_SUCCCESS = "SIGN_IN_SUCCCESS";
export const SIGN_OUT_SUCCCESS = "SIGN_OUT_SUCCCESS";
export const SET_CARDS = "SET_CARDS";

export const SET_LOCALE = "SET_LOCALE";
export const SET_SOCIAL_SIGNUP = "SET_SOCIAL_SIGNUP";
export const CLEAR_SOCIAL_SIGNUP = "CLEAR_SOCIAL_SIGNUP";

export const SET_SEARCH_SETTINGS = "SET_SEARCH_SETTINGS";
export const CLEAR_SEARCH_FILTER = "CLEAR_SEARCH_FILTER";
export const CLEAR_CURRENT_LOCATION = "CLEAR_CURRENT_LOCATION";

export const SET_PROFILE = "SET_PROFILE";
export const SET_CUSTOMER_POINTS_HISTORY = "SET_CUSTOMER_POINTS_HISTORY";

export const RESTAURANTS_FOUND = "RESTAURANTS_FOUND";
export const RESTAURANTS_CLEAR = "RESTAURANTS_CLEAR";
export const RESTAURANTS_ITEMS = "RESTAURANTS_ITEMS";

export const SET_ITEM = "SET_ITEM";
export const REMOVE_ITEM = "REMOVE_ITEM";

export const SET_ORDER = "SET_ORDER";
export const CLEAR_ORDER = "CLEAR_ORDER";

export const SET_TOKEN = "SET_TOKEN";

export const SET_PAYING = "SET_PAYING";

export const TOGGLE_CHECKOUT_ORDER_MODAL = "TOGGLE_CHECKOUT_ORDER_MODAL";
export const COLLAPSE_CHECKOUT_ORDER_MODAL = "COLLAPSE_CHECKOUT_ORDER_MODAL";

export const HOST_SET_URL = "HOST_SET_URL";
export const TOGGLE_GUESTS_EXPANDED = "TOGGLE_GUESTS_EXPANDED";
export const CLEAR_GROUP_ORDER_INFO = "CLEAR_GROUP_ORDER_INFO";

export const SET_FRIENDS = "SET_FRIENDS";

export const BANNER_RESTAURANTS_FOUND = "BANNER_RESTAURANTS_FOUND";
export const BANNER_RESTAURANTS_CLEAR = "BANNER_RESTAURANTS_CLEAR";
export const BANNER_RESTAURANTS_ITEMS = "BANNER_RESTAURANTS_ITEMS";
